<template>
  <a-modal
    :title="title"
    style="top: 20px;"
    :width="800"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-row :gutter="8">
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="客户编号"
          >
            <a-input
              autocomplete="false"
              v-decorator="[
                  'locationNo',
                  {initialValue:formdata.locationNo, rules: [{ required: true, message: '请输入客户编号' }]}
                ]"
            />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="客户名称"
          >
            <a-input
              autocomplete="false"
              v-decorator="[
                  'name',
                  {initialValue:formdata.name, rules: [{ required: true, message: '请输入客户名称' }]}
                ]"
            />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="客户类别"
          >
            <a-tree-select
              placeholder='请选择客户类别'
              treeDefaultExpandAll
              :treeData="categoryData"
              v-model="formdata.catId"
            >
            </a-tree-select>
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="纳税人识别号"
          >
            <a-input
              autocomplete="false"
              v-model="formdata.taxPayerNo"
            />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="开户银行"
        >
          <a-input
            autocomplete="false"
            v-model="formdata.bank"
          />
        </a-form-item>
      </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="银行账号"
          >
            <a-input
              autocomplete="false"
              v-model="formdata.cardNo"
            />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="联系人"
          >
            <a-input
              autocomplete="false"
              v-model="formdata.contactName"
            />
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="手机"
          >
            <a-input
              autocomplete="false"
              v-model="formdata.contactPhone"
            />
          </a-form-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-item
            :labelCol="{xs: { span: 24 },sm: { span: 4 }}"
            :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
            label="联系地址"
          >
            <a-input
              autocomplete="false"
              v-model="formdata.contactAddress"
            />
          </a-form-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-item
            :wrapperCol="{xs: { span: 24 },sm: { span: 24 }}"
          >
            <a-textarea
              placeholder="添加备注信息"
              :autosize="{ minRows: 2, maxRows: 6 }"
              v-model="formdata.note"
            />
          </a-form-item>
        </a-col>
      </a-row>

    </a-form>
  </a-modal>
</template>

<script>
import { getCategoryCustomer } from '@/api/category'
import { editCustomer, addCustomer } from '@/api/customer'
import { CODE_FAIL } from '@/store/mutation-types'
export default {
  name: 'CustomerForm',
  props: {
    title: {
      type: String,
      default: '新增'
    },
    visible: {
      type: Boolean,
      default: false
    },
    isEditForm: {
      type: Boolean,
      default: false
    },
    formdata: {
      type: Object,
      default: () => ({
        locationNo: '',
        taxPayerNo: '',
        name: '',
        catId: '0',
        bank: '',
        cardNo: '',
        note: '',
        contactName: '',
        contactPhone: '',
        contactAddress: ''
      })
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      categoryData: null,
      form: this.$form.createForm(this, this.formdata)
    }
  },
  beforeCreate () {
  },
  created () {
    this.loadCategory()
  },
  methods: {
    loadCategory () {
      getCategoryCustomer({ tree: true })
        .then(res => {
          this.categoryData = res.result
        })
    },
    handleOk () {
      const vm = this
      this.form.validateFields((err, values) => {
        if (!err) {
          const datas = Object.assign({}, this.formdata, values)
          if (this.isEditForm) {
            editCustomer(datas).then(res => {
              if (res.status !== CODE_FAIL) {
                this.form.resetFields()
                this.$message.success('修改成功')
                vm.$emit('formsuccess', datas)
              } else {
                this.$message.error(res.message)
              }
            })
          } else {
            addCustomer(datas).then(res => {
              if (res.status !== CODE_FAIL) {
                this.form.resetFields()
                this.$message.success('新增成功')
                vm.$emit('formsuccess', datas)
              } else {
                this.$message.error(res.message)
              }
            })
          }
        }
        vm.$emit('formerror', err)
      })
    },
    handleCancel () {
      this.$emit('formcancel')
    }
  }
}
</script>
